var map = {
	"./af.yml": "1831",
	"./bd.yml": "7e03",
	"./bf.yml": "46c7",
	"./bg.yml": "2aa5",
	"./bp.yml": "52cb",
	"./cc.yml": "c8bf",
	"./ct.yml": "e2d6",
	"./da.yml": "0770",
	"./de.yml": "363b",
	"./el.yml": "a6fa",
	"./en.yml": "eb57",
	"./es.yml": "4020",
	"./fc.yml": "1043",
	"./fr.yml": "8755",
	"./hg.yml": "d645",
	"./il.yml": "5070",
	"./it.yml": "2055",
	"./ja.yml": "d602",
	"./ko.yml": "096c",
	"./lp.yml": "8889",
	"./lt.yml": "5306",
	"./nl.yml": "31f5",
	"./ns.yml": "b6c8",
	"./pl.yml": "958c",
	"./pt.yml": "67c3",
	"./ro.yml": "cc8f",
	"./sk.yml": "6b5d",
	"./sp.yml": "c42c",
	"./sr.yml": "5d09",
	"./st.yml": "e365",
	"./sv.yml": "9d6a",
	"./th.yml": "e0ee",
	"./tl.yml": "a790",
	"./tn.yml": "68b4",
	"./tr.yml": "a0db",
	"./xh.yml": "c64d",
	"./zh.yml": "1cbb",
	"./zu.yml": "afa7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c36";